import React, {Fragment, useEffect, useState} from 'react';

import '../../../App.css';
import {useAppDispatch, useAppSelector} from "../../../feature/tools";
import {Avatar, Button, Flex, Input, Space, Typography} from "antd";
import TextArea from "antd/es/input/TextArea";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowUpFromBracket} from "@fortawesome/free-solid-svg-icons";
import {fetchProjects, updateProject} from "../../../feature/project/projectsSlice";
import {Status} from "../../../feature/project/status";
import {UploadButton} from "../../../components/UploadButton";
import {Cover} from "../../../components/Cover";
import {Description} from "../../../typography/Description";
import {Project} from "../../../feature/project/project";
import Title from "antd/es/typography/Title";
import {useParams} from "react-router-dom";
import {saveProjectStorageProvider} from "../../../feature/project/storageSlice";
import {FilesBrowserModal} from "../../common/FilesBrowser";

const ProjectGeneralSettings = (
    props: {
        onChange?: (project: Project) => void,
        saveFunction: (saveFunction: () => void) => void
    }
) => {
    const dispatch = useAppDispatch()
    const [browserVisible, setBrowserVisible] = React.useState(false)
    const project = useAppSelector(state => state.projects.project)
    const {projectId} = useParams()
    const user = useAppSelector(state => state.users.currentUser)
    const [title, setTitle] = useState(project?.title || "")
    const [description, setDescription] = useState(project?.description || "")
    const [cover, setCover] = useState(project?.cover || "")
    const [icon, setIcon] = useState(project?.icon || "")
    const creator = useAppSelector(state => state.users.creator)

    useEffect(() => {
        dispatch(fetchProjects())
    }, [projectId])

    useEffect(() => {
        setTitle(project?.title || "")
        setDescription(project?.description || "")
        setCover(project?.cover || "")
        setIcon(project?.icon || "")
    }, [project])

    useEffect(() => {
        props.onChange?.({
            id: project?.id || 0,
            title: title,
            description: description,
            icon: icon,
            cover: cover
        })
    }, [title, description, icon, cover]);

    useEffect(() => {
        props.saveFunction(() => {
            if (project) {
                dispatch(updateProject(
                    {
                        id: project?.id || 0,
                        title: title,
                        description: description,
                        icon: icon,
                        cover: cover
                    }
                ))
            }
        })
    }, [project, title, description, icon, cover]);

    return (
        <Flex gap={20} justify={'center'} align={'top'}
              style={{overflowY: 'auto', scrollbarWidth: "none", overflowX: 'hidden', width: '100%'}} vertical={true}>
            {project ?
                <Title level={5} style={{margin: 0, paddingTop: 10}}>Project Settings</Title> : ''}
            <Flex gap={20}>
                {project ? <Cover
                        projectId={projectId}
                        style={{position: "relative", width: 200, minHeight: 200}}
                        alt={title}
                        cover={cover}
                        onFileUploaded={(url: string) => setCover(url)}
                        onFileDeleted={() => setCover('')}/>
                    : ''}
                <Space direction={'vertical'} size={20} style={{flexGrow: 1}}>
                    <div>
                        <Typography style={{fontWeight: 700}}>Project Title</Typography>
                        <Input value={title} onChange={(event) => setTitle(event.target.value)}/>
                        <Description value={'Name of your project (e.g. The Lord of The Rings)'}/>
                    </div>
                    <div>
                        <Typography style={{fontWeight: 700}}>Project Description</Typography>
                        <TextArea rows={5} value={description}
                                  onChange={(event) => setDescription(event.target.value)}/>
                        <Description value={'Describe you project in a couple of sentences'}/>
                    </div>
                    {project ? <div>
                        <Typography style={{fontWeight: 700}}>Icon</Typography>
                        <Space>
                            <Avatar src={icon} size={32} shape={'square'}/>
                            <Button style={{background: "#fff"}}
                                    onClick={() => setBrowserVisible(true)}
                            >Select Icon</Button>
                        </Space>
                        <Description
                            value={'Will be used to display in the lists to easily identify the project.'}/>
                    </div> : ''}
                </Space>
            </Flex>
            {
                browserVisible ? <FilesBrowserModal
                    root={(creator?.id + "/") + (projectId ? (projectId + "/") : "")}
                    onDismiss={() => setBrowserVisible(false)}
                    onSelect={(url) => {
                        setIcon(url)
                        setBrowserVisible(false)
                    }}
                    types={['images']}
                /> : ''
            }
        </Flex>

    );
};

export default ProjectGeneralSettings;